import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { MsalModule, MsalInterceptor, MsalService, MsalGuard, MsalBroadcastService } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.auth.clientId,
    authority: environment.auth.authority,
    redirectUri: environment.auth.redirectUri
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
});

async function main() {
  // Initialize MSAL and handle the redirect response *before* Angular starts
  await msalInstance.initialize();
  const result = await msalInstance.handleRedirectPromise();
  if (result?.account) {
    msalInstance.setActiveAccount(result.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length) msalInstance.setActiveAccount(accounts[0]);
  }

  await bootstrapApplication(AppComponent, {
    providers: [
      provideHttpClient(withInterceptorsFromDi()),
      importProvidersFrom(
        MsalModule.forRoot(
          msalInstance,
          {
            interactionType: InteractionType.Redirect,
            authRequest: { scopes: ['.default'] }
          },
          {
            interactionType: InteractionType.Redirect,
            protectedResourceMap: new Map()
          }
        )
      ),
      // Enable MSAL interceptor (only needed if you call protected APIs later)
      { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },

      MsalService,
      MsalGuard,
      MsalBroadcastService
    ]
  });
}

main().catch(console.error);
